export const DARK_MAP_STYLE=[
 {elementType:'geometry',stylers:[{color:'#172238'}]},
 {elementType:'labels.text.fill',stylers:[{color:'#bac7df'}]},
 {elementType:'labels.text.stroke',stylers:[{color:'#172238'}]},
 {featureType:'road',elementType:'geometry',stylers:[{color:'#394966'}]},
 {featureType:'road.highway',elementType:'geometry',stylers:[{color:'#65738e'}]},
 {featureType:'water',elementType:'geometry',stylers:[{color:'#0b1628'}]},
 {featureType:'poi.park',elementType:'geometry',stylers:[{color:'#1b352f'}]},
];
